<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eLzvE6/tc-custom/9781612435176.jpg?1729379520057" alt="This image is the cover for the book Botanical Hand Lettering Workbook"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Botanical Hand Lettering Workbook
      </h1>
      <p class="bookDescription body article font2">
        <b>Foreword INDIE Silver Winner for Crafts &amp; Hobbies. Create exquisite hand-lettered works of art by learning how to draw ornamental fonts and flourishes.</b><br/><br/>Learn the art of hand-lettering. This step-by-step workbook teaches you how to craft pretty letters and flowers of all sorts. Use your newfound botanical lettering skills to make cards, wedding invitations, banners, tags, paper bouquets, and other fun projects.<br/><br/><b>“If you are someone who wants to create something beautiful with doodling and drawing, this book will inspire you and help you to learn the skills. I LOVED it!” —<i>Tea Rose Home</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bethany Robertson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Ulysses Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3fc0b951